export const ACCEPT_OPT_IN = 'options/ACCEPT_OPT_IN';
export const COMPLETE_STEP = 'options/COMPLETE_STEP';
export const DECLINE_OPT_IN = 'options/DECLINE_OPT_IN';
export const EMBARGO_PERIOD_CHANGED = 'options/EMBARGO_PERIOD_CHANGED';
export const LOCAL_STORAGE_LOADED = 'options/LOCAL_STORAGE_LOADED';
export const LOCAL_STORAGE_SYNCED = 'options/LOCAL_STORAGE_SYNCED';
export const SET_TERMS_LOADING = 'options/SET_TERMS_LOADING';
export const UNDO_OPT_IN = 'options/UNDO_OPT_IN';
export const VIEW_OPT_IN_TERMS = 'options/VIEW_OPT_IN_TERMS';

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});
export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });



// WEBPACK FOOTER //
// ./src/options/optionsActions.js